import React from "react";
import "../list-component/styles.css";
import Text from "../typography/text.js";
import RightArrowIcon from "../../icons/right-arrow.js";
import TwoArrowUp from "../../icons/two-arrow-up.js";
import ChangeIndicator from "../change-indicator/change-indicator.js";
import { formatNumber } from "../card/index.js";
import { useScreen } from "../../components/Utils/Screens.js";
import Tags from "../../common/tags/index.js";
// interface IListItem {
//   DistributorName?: string;
//   secondaryName?: string;
//   number?: string;
//   percent?: string;
// }

// interface QuickListProps {
//   listTitle: string;
//   totalAmount?: Number;
//   items: IListItem[];
// }

const QuickList = ({
  listTitle,
  listType = "list",
  items,
  emptyItemListErrorText = "",
  totalAmount,
  primaryTitle,
  secondaryTitle,
  tertiaryTitle,
  price,
  handleShowViewProduct,
  setProductItem,
  tagKey,
  page = "Accounts",
  priceHeader,
  priceHeaderValue,
}) => {
  const isPhone = !useScreen("md");

  const viewProductDetails = (item) => {
    console.log(item, "item >>>> 1");
    setProductItem(item);
    handleShowViewProduct();
  };
  // const [whole, decimal] = formatNumber(price).split(".");

  return (
    // <div className="quick-list-container">
    //   <div className="quick-list-header-container">
    //     <div className="quick-list-title">
    //       <Text variant="tinyText">{listTitle}</Text>
    //       <RightArrowIcon className="quick-list-icon" />
    //     </div>
    //     {totalAmount && <Text variant="numberBig">${whole}</Text>}
    //   </div>
    //   {items.map((item) => {
    //     return (
    //       <div className="quick-list-item-container">
    //         <div className="quick-list-item-container-left">
    // <Text variant="tinyText" color="darkText">
    //   {item?.[primaryTitle]}
    // </Text>
    // {item?.[secondaryTitle] && (
    //   <Text
    //     variant="tinyText"
    //     color="lightText"
    //     className="secondary-content-container"
    //   >
    //     {item?.[secondaryTitle]}
    //   </Text>
    // )}
    //         </div>
    //         {item?.[price] && (
    //           <div
    //             style={{
    //               display: "flex",
    //               flexDirection: "row",
    //               justifyContent: "center",
    //               alignItems: "center",
    //               gap: "8px",
    //             }}
    //           >
    // <Text variant="tinyText" color="darkText">
    //   {item?.[price]}
    // </Text>
    //             <ChangeIndicator variant="positive" percent={item?.percent} />
    //           </div>
    //         )}
    //       </div>
    //     );
    //   })}
    // </div>

    // NEW
    <>
      <div
        className={
          listType === "modal"
            ? `modal-quick-list-container`
            : `quick-list-container`
        }
        style={
          isPhone
            ? { width: "fill-available", cursor: "pointer" }
            : { cursor: "pointer" }
        }
      >
        {listTitle && <Text variant="tinyText">{listTitle}</Text>}
        {items?.length !== 0 ? (
          items?.map((item) => {
            console.log(item, "primaryTitle item in quick list >>>>> 1");
            const [whole, decimal] = formatNumber(item?.[price]).split(".");

            return (
              <div
                className="quick-list-item-container"
                onClick={() => viewProductDetails(item)}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "28px",
                  }}
                >
                  <div className="quick-list-item-container-left">
                    {page === "Invoices" ? (
                      <>
                        {(item?.[tertiaryTitle] || item?.[secondaryTitle]) && (
                          <Text variant="tinyText" color="darkText">
                            {[item?.[tertiaryTitle], item?.[secondaryTitle]]
                              .filter(Boolean)
                              .join(" · ")}
                          </Text>
                        )}
                        {item?.[primaryTitle] && (
                          <Text
                            variant="tinyText"
                            color="lightText"
                            className="secondary-content-container"
                          >
                            {item?.[primaryTitle]}
                          </Text>
                        )}
                      </>
                    ) : (
                      <>
                        <Text variant="tinyText" color="darkText">
                          {item?.[primaryTitle]}
                        </Text>
                        {item?.[secondaryTitle] && (
                          <Text
                            variant="tinyText"
                            color="lightText"
                            className="secondary-content-container"
                          >
                            {item?.[secondaryTitle]}
                          </Text>
                        )}
                      </>
                    )}
                  </div>
                  {/* add a condition here for tagKey and make it more generic */}
                  {page === "Invoices" &&
                    item?.IsSentToCollection && (
                      <Tags
                        textColor="primaryColor"
                        tagBackground="blueBackground"
                        tagText="Sent To Collection"
                      />
                    )}
                  {page === "Invoices" &&
                    item?.ReturnStarted &&
                    !item.ReturnCompleted && (
                      <Tags
                        textColor="failureColorDark"
                        tagBackground="failureColorLight"
                        tagText="Return In Progress"
                      />
                    )}
                  {page === "Invoices" &&
                    (item.ReturnCompleted || item.IsReturned) && (
                      <Tags
                        textColor="failureColorDark"
                        tagBackground="failureColorLight"
                        tagText="Returned"
                      />
                    )}
                  {item?.[tagKey] ? (
                    <Tags
                      textColor="successColorDark"
                      tagBackground="successColorLight"
                      tagText={page === "Accounts" ? "Available" : "Active"}
                    />
                  ) : page === "Accounts" ? (
                    <Tags
                      textColor="failureColorDark"
                      tagBackground="failureColorLight"
                      tagText="Unavailable"
                    />
                  ) : (
                    <></>
                  )}
                </div>

                {item?.[price] ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                      alignItems: "flex-end",
                    }}
                  >
                    {priceHeader && (
                      <Text variant="tinyText">
                        {priceHeader}: {item?.[priceHeaderValue]}
                      </Text>
                    )}
                    <div className="quick-list-item-container-right">
                      <Text variant="bodyText" color="darkText">
                        ${whole}
                        <Text variant="bodyText" color="strokeDark">
                          .{decimal}
                        </Text>
                      </Text>
                    </div>
                  </div>
                ) : null}
              </div>
            );
          })
        ) : (
          <Text variant="bodyText">{emptyItemListErrorText}</Text>
        )}
      </div>
    </>
  );
};

export default QuickList;
